"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirebaseAuthRedirectPage = void 0;
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var FirebaseAuthRedirectPage = function () {
    var navigate = (0, react_router_dom_1.useNavigate)();
    var params = (0, react_router_dom_1.useParams)();
    var location = (0, react_router_dom_1.useLocation)();
    (0, react_1.useEffect)(function () {
        if (location) {
            var searchParams = new URLSearchParams(location.search);
            var mode = searchParams.get("mode");
            var oobCode = searchParams.get("oobCode");
            switch (mode) {
                case "resetPassword":
                    navigate("/auth/password/reset/".concat(oobCode));
                    break;
                case "verifyEmail":
                    navigate("/auth/verify/email/".concat(oobCode));
                    break;
                case "verifyAndChangeEmail":
                    navigate("/auth/verify/email/".concat(oobCode));
                    break;
            }
        }
    }, [location]);
    return (react_1.default.createElement(doshx_controls_web_1.ScreenContainerControl, null,
        react_1.default.createElement(doshx_controls_web_1.ShimmerBoxControl, null)));
};
exports.FirebaseAuthRedirectPage = FirebaseAuthRedirectPage;
